import FeedLayout from "layouts/files/FeedLayout";
import { SettingsItem } from "ui";

const Settings = () => {
    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page">
                <div className="w-full text-center mb-30 mt-20">
                    <h1 className="fw-700 fs-12em">Settings</h1>
                </div>
                <div className="card pl-10 pr-10 pt-10 pb-10">
                    {/* account */}
                    <SettingsItem
                        svg="user"
                        title="Your Account"
                        details="See information about your account, update your details also deception option."
                        link="/settings/account"
                    />
                    {/* msgs */}
                    <SettingsItem
                        svg="message-circle"
                        title="Direct Messages"
                        details="To reduce unwanted messages from people who are follower or not."
                        link="/settings/messages"
                    />
                    {/* notifications */}
                    <SettingsItem
                        svg="bell"
                        title="Notifications"
                        details="Select your kinds of notification you get about your activities, interest and recommendtions."
                        link="/settings/notifications"
                    />
                    {/* topics */}
                    <SettingsItem
                        svg="s-topics"
                        title="About your interest on Topics"
                        details="Select topic which you are interested and grow your knowledge about selecting more topics."
                        link="/topics"
                    />
                    {/* langs */}
                    <SettingsItem
                        svg="langs"
                        title="Set Languages which you interested"
                        details="Select languages which you are interested and grow your knowledge and your content on Momeento."
                        link="/settings/langs"
                    />
                    {/* prefrence */}
                    <SettingsItem
                        svg="user-x"
                        title="Your Prefrence, Followers restrictions"
                        details="Select followers from your following or followers list and block user to not sending any messages and not to show your posts and incidents."
                        link="/settings/prefrence"
                    />
                    {/* privacy */}
                    <SettingsItem
                        svg="lock"
                        title="Privacy and Safety"
                        details="Manage what information regarding post and incidents you see and share on Momeento."
                        link="/privacy"
                        className="mb-20"
                    />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Settings;
